/* global G, PLATFORM */
import settings from '@tenant/settings'
import { asyncPipeSpread, deleteKey } from 'lib/util'
import { show } from 'lib/sequence/component/state/hidden'
import find from 'lib/sequence/component/children/find'
import session from 'app/_shared/session'
import getUserRole from 'app/_shared/events/user/role'

/**
 * Toggles the display of the home banners according to the `showHomeBanner` setting.
 *
 * @param {Gaia.AppModule.Spec} module current module
 * @return {function(*, ...[*]): *[]}
 */
const displayCustomElements = module => (components, ...args) => {
  const { user } = session(module)
  const { headerBanner, welcomeBanner, reqApmGo, fseApmGo, optionManagementCard } = components
  const { showHomeBanner, showApmGo } = settings

  showHomeBanner
    && (PLATFORM === 'mobile' ? show(headerBanner) : show(welcomeBanner))

  showApmGo && show(reqApmGo) && show(fseApmGo)

  if (PLATFORM === 'web' && optionManagementCard) {
    const userRole = getUserRole(user.ref()?.value?.roles, module, null, null)?.key
    // PinCreator only sees one card, we need to remove block props so it's not squished
    userRole === 'PinCreatorOnly_c' && deleteKey('block', optionManagementCard[G.PROPS])
  }

  return [components, ...args]
}

/**
 * EquipmentInformation Equipment Action
 *
 * @param {Gaia.AppModule.Spec} module current module
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayCustomElements(module),
  (components, ...args) => args,
)(find(component), ...args)
